// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".client-Components-RawHtml-RawHtml-module__root--KHrNe {\n  contain: paint;\n}\n/*# sourceMappingURL=RawHtml.module.css.map */", "",{"version":3,"sources":["webpack://./RawHtml.module.less","webpack://./client/Components/RawHtml/RawHtml.module.less"],"names":[],"mappings":"AAAA;EACC,cAAA;ACCD;AACA,6CAA6C","sourcesContent":[".root {\n\tcontain: paint;\n}",".root {\n  contain: paint;\n}\n/*# sourceMappingURL=RawHtml.module.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "client-Components-RawHtml-RawHtml-module__root--KHrNe"
};
export default ___CSS_LOADER_EXPORT___;
